// Site Templates Configuration
// Each template has unique colors, fonts, and default content

export const SITE_TEMPLATES = {
  ecommerce: {
    id: 'ecommerce',
    name: 'E-Commerce Store',
    description: 'Product-first layout built for online stores and retail brands',
    preview: '',
    colors: {
      primary: '#E63946',
      secondary: '#F4A261',
      accent: '#E9C46A',
      background: '#FFFFFF',
      text: '#0A0A0A'
    },
    fonts: {
      heading: 'Manrope',
      body: 'Manrope'
    },
    defaultContent: {
      hero: {
        title: 'New Arrivals',
        tagline: 'Shop the latest collection — free shipping on orders over $75',
        button_text: 'Shop Now'
      },
      banners: [
        { text: 'End of Season Sale — Up to 50% Off' },
      ],
      about: {
        title: 'Our Brand',
        text: 'Quality products curated with care. We believe in making exceptional items accessible to everyone.',
        vision: 'Great style, honest prices.'
      },
      signup: {
        title: 'Get 10% Off Your First Order',
        subtitle: 'Subscribe for exclusive drops, restocks, and member-only deals'
      }
    }
  },

  booking: {
    id: 'booking',
    name: 'Booking & Services',
    description: 'Appointment-driven layout for salons, spas, and service providers',
    preview: '',
    colors: {
      primary: '#D4A574',
      secondary: '#8B7355',
      accent: '#F5EDE3',
      background: '#FFFEF7',
      text: '#1A1A1A'
    },
    fonts: {
      heading: 'Manrope',
      body: 'Manrope'
    },
    defaultContent: {
      hero: {
        title: 'Book Your Appointment',
        tagline: 'Premium care, tailored to you',
        button_text: 'Book Now'
      },
      banners: [],
      about: {
        title: 'About Us',
        text: 'With over a decade of experience, our team is passionate about delivering exceptional results.',
        vision: 'Your satisfaction is our craft.'
      },
      signup: {
        title: 'Stay in the Loop',
        subtitle: 'Get appointment reminders, seasonal promotions, and tips'
      }
    }
  },

  portfolio: {
    id: 'portfolio',
    name: 'Artist & Portfolio',
    description: 'Visual-first layout for artists, photographers, and creatives',
    preview: '',
    colors: {
      primary: '#8B5CF6',
      secondary: '#6D28D9',
      accent: '#DDD5F3',
      background: '#0A0A0A',
      text: '#F5F5F5'
    },
    fonts: {
      heading: 'Manrope',
      body: 'Manrope'
    },
    defaultContent: {
      hero: {
        title: 'The Work Speaks',
        tagline: 'Exploring light, texture, and emotion through mixed media',
        button_text: 'View Gallery'
      },
      banners: [],
      about: {
        title: 'About the Artist',
        text: 'Working at the intersection of traditional technique and digital experimentation.',
        vision: 'Creating art that resonates.'
      },
      signup: {
        title: 'Follow the Journey',
        subtitle: 'Exhibition dates, new releases, and behind-the-scenes updates'
      }
    }
  }
};

export const getTemplateById = (id) => {
  return SITE_TEMPLATES[id] || SITE_TEMPLATES.ecommerce;
};

export const getTemplatesList = () => {
  return Object.values(SITE_TEMPLATES);
};
